export default {"src":"/_next/static/media/write.759fa94e.svg","height":610,"width":818,"blurWidth":0,"blurHeight":0};